module.exports = __webpack_public_path__ + "img/mealplan-index.38a09b72.gif";